export default __webpack_public_path__ + "static/media/manejo_temperatura_hipotermia_terapeutica.2f0fb4fc.pdf";